import {
  UilAirplay,
  UilApps,
  UilBriefcaseAlt,
  UilEstate,
  UilMessage,
  UilScenery,
  UilStar,
  UilTimes,
  UilUser,
} from "@iconscout/react-unicons";
import React, { useState } from "react";
import "./Header.css";
import NavItem from "./NavItem";
import LogoImg from "./NugaLogo.png";
import Toggle from "./Toggle";

function Header() {
  const [showNav, setShowNav] = useState(false);

  return (
    <header className="header">
      <nav className="nav container">
        <a href="#home" className="nav__logo">
          {/* theTechBoi.nugagee */}
          <img class="logo-img" src={LogoImg} alt="Logo-img" />
          <h2>
            theTechBoi.
            <span style={{ color: "red" }}>
              <i>nugagee</i>
            </span>
          </h2>
        </a>
        <div className={`nav__menu ${showNav ? "show-nav" : "hide-nav"}`}>
          <ul className="nav__list grid">
            <NavItem Icon={UilEstate} name="Home" link="#home" />
            <NavItem Icon={UilUser} name="About" link="#about" />
            <NavItem Icon={UilBriefcaseAlt} name="Skills" link="#services" />
            <NavItem Icon={UilScenery} name="Projects" link="#project" />
            <NavItem Icon={UilMessage} name="Contact" link="#contact" />
            <NavItem Icon={UilAirplay} name="Experience" link="#experience" />
            <NavItem Icon={UilStar} name="Get a quote" />
          </ul>
          <UilTimes className="nav__close" onClick={() => setShowNav(false)} />
        </div>

        <div className="nav__btns">
          <Toggle />
          <UilApps onClick={() => setShowNav(true)} className="nav__toggle" />
        </div>
      </nav>
    </header>
  );
}

export default Header;
